import { call, put, takeLatest } from "redux-saga/effects";
import axiosMain from "../../../http/axios/axios_main";
import * as actionLabels from "../../actionLabels";
import { getReferenceNoFailure, getReferenceNoSuccess } from "../../actions";

function* getReferenceNoSaga() {
    try {
      const response = yield call(axiosMain.get, `/postauction/buyertaxinvoice/getrefernceno`, {});
      // if (response.data == 200) {
      yield put(getReferenceNoSuccess(response.data));
      // } else {
      //   yield put(getAllTeaTypesSuccess(response.message));
      // }
    } catch (error) {
      yield put(getReferenceNoFailure(error.message));
    }
  }

  export function* referenceNoSaga() {
    yield takeLatest(actionLabels.GET_REFERENCE_NO_REQUEST, getReferenceNoSaga);
  }
  